window.CREPHUT = {
  brand: "CREPHUT",
  email: "info@crephut.com",
  founded: 2014,
  currency: "GBP",
};

window.CREPHUT_STORIES = [
  { label: "Saucony", href: "shop.html?brand=saucony", image: "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/SAUCONY_OMNI_9_NAVY_S70739-41.webp?v=1771592611" },
  { label: "P-6000", href: "shop.html?model=p-6000", image: "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-21_at_13.45.53.png?v=1745240369" },
  { label: "Jordan 1", href: "shop.html?brand=jordan", image: "https://cdn.shopify.com/s/files/1/0985/2032/products/COURTPURPLE2.jpg?v=1604280192" },
  { label: "Jordan 4", href: "shop.html?model=jordan-4", image: "https://cdn.shopify.com/s/files/1/0985/2032/files/air-jordan-4-retro-fire-red-2020-dc7770-160_1_pf2i3n_1800x1800_1.jpg?v=1716665482" },
  { label: "Air Max 95", href: "shop.html?model=air-max-95", image: "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-16_at_10.25.29.png?v=1772906338" },
  { label: "Air Max 97", href: "shop.html?model=air-max-97", image: "https://cdn.shopify.com/s/files/1/0985/2032/products/SW_97_1.jpg?v=1521511739" },
  { label: "Yeezy", href: "shop.html?brand=yeezy", image: "images/catalogue/yeezy-350-v2-cloud-white.jpg" },
  { label: "Off-White", href: "shop.html?brand=off-white", image: "images/catalogue/off-white-am90-desert-ore.jpg" },
  { label: "Patta", href: "product.html?id=nike-air-max-1-patta-waves-white", image: "https://cdn.shopify.com/s/files/1/0985/2032/products/patta1_96b20052-2885-4a33-8fc3-5db380b87a9e.jpg?v=1707794566" },
  { label: "AF1", href: "shop.html?model=air-force-1", image: "https://cdn.shopify.com/s/files/1/0985/2032/products/Shibuya_AF1.jpg?v=1573581334" },
];

window.CREPHUT_PRODUCTS = [
  {
    id: "saucony-og-progrid-omni-9-deep-navy",
    title: "Saucony OG ProGrid Omni 9 'Deep Navy'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 249.99,
    badge: "New",
    featured: true,
    sizes: ["4", "4.5", "5", "5.5", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/SAUCONY_OMNI_9_NAVY_S70739-41.webp?v=1771592611",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-20T124753.867_a3450496-8c8e-4f09-930b-8a8cf7f7e22d.png?v=1771593293",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-20T124731.941.png?v=1771593293",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-20T124933.222.png?v=1771593293",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-20T124851.541.png?v=1771593293",
    ],
    description: "Deep Navy on the OG ProGrid Omni 9. We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S70739-41.",
  },
  {
    id: "saucony-progrid-omni-9-teal-grey",
    title: "Saucony ProGrid Omni 9 'Teal Grey'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: true,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
    images: ["https://cdn.shopify.com/s/files/1/0634/9229/2787/files/saucony_omni_9_teal.png?v=1784743705"],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S71064-3.",
  },
  {
    id: "saucony-progrid-omni-9-grey-silver",
    title: "Saucony ProGrid Omni 9 'Grey Silver'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: false,
    sizes: ["4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/saucony-progrid-omni-9-silver-grey-s70739-42-side.webp?v=1773249892",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-03-11T171804.942.png?v=1773249892",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-03-11T171726.718.png?v=1773249892",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-03-11T171853.460.png?v=1773249892",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-03-11T171924.222.png?v=1773249892",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S70739-42.",
  },
  {
    id: "saucony-progrid-omni-9-white-sky-blue",
    title: "Saucony ProGrid Omni 9 'PLEIN AIR'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: false,
    sizes: ["3", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/jpg_20.webp?v=1780849573",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_36.png?v=1783972611",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_34.png?v=1783972608",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_37.png?v=1783972611",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_35.png?v=1783972611",
    ],
    description: "White Sky Blue / Plein Air. We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S70739-44.",
  },
  {
    id: "saucony-og-progrid-omni-9-pine-green",
    title: "Saucony OG ProGrid Omni 9 'Pine Green'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: false,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "11", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/SAUCONY_OMNI_9_PINE_GREEN.webp?v=1771262638",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-02-06T154644.729.png?v=1771262709",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-02-06T154629.579.png?v=1771262709",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-02-06T154801.633.png?v=1771262709",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2026-02-06T154716.514.png?v=1771262709",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S70739-56.",
  },
  {
    id: "saucony-progrid-omni-9-black-orange",
    title: "Saucony ProGrid Omni 9 'BLACK ORANGE'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: false,
    sizes: ["7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/314218297704_01.webp?v=1774447793",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-03-25T142608.624.png?v=1774449031",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-03-25T142726.810.png?v=1774451065",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-03-25T143208.734.png?v=1774451065",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-03-25T142536.946.png?v=1774450098",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-03-25T142658.081.png?v=1774450098",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S71057-2.",
  },
  {
    id: "saucony-progrid-omni-9-black-red-blue",
    title: "Saucony ProGrid Omni 9 'Black Multi Red Blue'",
    brand: "saucony",
    model: "progrid-omni-9",
    price: 199.99,
    badge: "New",
    featured: false,
    sizes: ["7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/IMG-2569_1.webp?v=1786206525",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_45.png?v=1785254190",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_43.png?v=1785254185",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_44.png?v=1785254188",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_26_March_2025_at_11.41.54_42.png?v=1785254188",
    ],
    description: "No shoe box included. We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU S70739-58.",
  },
  {
    id: "nike-air-max-95-og-neon-2025",
    title: "NIKE AIR MAX 95 OG 'NEON' (2026)",
    brand: "nike",
    model: "air-max-95",
    price: 359,
    badge: "New",
    featured: true,
    sizes: ["5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "13"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-16_at_10.25.29.png?v=1772906338",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-03T163604.343.png?v=1744795592",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-03T163542.125.png?v=1744795592",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-04-02T172836.884.png?v=1744795592",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-04-02T172949.645.png?v=1744795592",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU HM4740-001.",
  },
  {
    id: "nike-air-max-95-pink-foam-2025",
    title: "NIKE AIR MAX 95 OG PINK FOAM (2025)",
    brand: "nike",
    model: "air-max-95",
    price: 332,
    badge: "New",
    featured: false,
    sizes: ["5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-23_at_12.54.59.png?v=1745409479",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-05-01T110225.557.png?v=1746094131",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-05-01T105937.839.png?v=1746094131",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-05-01T110121.902.png?v=1746094131",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-05-01T110035.709.png?v=1746094131",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU HJ5996-001.",
  },
  {
    id: "nike-p-6000-summit-white",
    title: "NIKE P-6000 'SUMMIT WHITE'",
    brand: "nike",
    model: "p-6000",
    price: 144.99,
    badge: "New",
    featured: true,
    sizes: ["3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-21_at_13.45.53.png?v=1745240369",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-21T135615.112.png?v=1745240383",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-21T135527.904.png?v=1745240389",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-21T135515.192.png?v=1745240375",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-04-21T135550.386.png?v=1745240383",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU FV6603-101.",
  },
  {
    id: "nike-p-6000-light-army-khaki",
    title: "NIKE P-6000 PREMIUM 'LIGHT ARMY KHAKI'",
    brand: "nike",
    model: "p-6000",
    price: 194,
    badge: "New",
    featured: false,
    sizes: ["5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-04-16_at_10.30.13.png?v=1769794507",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-10-01T192735.612.png?v=1769794507",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-10-01T192730.228.png?v=1769794507",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-10-01T192725.709.png?v=1769794507",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-10-01T192545.865.png?v=1769794507",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU IH0246-320.",
  },
  {
    id: "nike-p-6000-suede-anthracite-metallic-silver",
    title: "NIKE P-6000 'SUEDE ANTHRACITE METALLIC SILVER'",
    brand: "nike",
    model: "p-6000",
    price: 139.99,
    badge: "New",
    featured: false,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "11"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/NIKE_P000_SUEDE_ANTHRACITE_METALLIC_SILVER.webp?v=1769265411",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-19T144245.674.png?v=1771512246",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-19T144220.240.png?v=1771512266",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2026-02-19T144137.932.png?v=1771512273",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU HF0015-002.",
  },
  {
    id: "nike-p-6000-winterised-anthracite-grey",
    title: "NIKE P-6000 WINTERISED 'ANTHRACITE GREY'",
    brand: "nike",
    model: "p-6000",
    price: 144.99,
    badge: "New",
    featured: false,
    sizes: ["5.5", "7", "7.5", "8", "9", "10.5"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-01-15_at_10.45.28.png?v=1736938020",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-03-04_at_13.07.19.png?v=1741093898",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-01-15_at_10.40.48.png?v=1741093898",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-03-04_at_13.07.40.png?v=1741093743",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU HQ3818-001.",
  },
  {
    id: "nike-p-6000-cool-grey-black",
    title: "NIKE P-6000 'COOL GREY BLACK'",
    brand: "nike",
    model: "p-6000",
    price: 129.99,
    badge: "New",
    featured: false,
    sizes: ["6", "6.5", "7", "7.5", "8", "9", "11", "11.5"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled_-_2025-07-16T173804.567.png?v=1752685493",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175557.498.png?v=1752685383",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175748.930.png?v=1752685383",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175530.816.png?v=1752685382",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175654.760.png?v=1752685383",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175822.291.png?v=1752685384",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Untitled-2025-07-16T175851.630.png?v=1752685383",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU IF6199-003.",
  },
  {
    id: "nike-p-6000-premium-white-metallic-silver-black",
    title: "NIKE P-6000 'WHITE METALLIC SILVER BLACK'",
    brand: "nike",
    model: "p-6000",
    price: 194,
    badge: "New",
    featured: false,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5"],
    images: [
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/Screenshot_2025-03-19_at_13.57.28.png?v=1742392701",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/nike-p-6000-white-metallic-silver-black-cd6404-107-back_w1024_h1024_pad__jpg.webp?v=1742394307",
      "https://cdn.shopify.com/s/files/1/0634/9229/2787/files/nike-p-6000-white-metallic-silver-black-cd6404-107-side_w1024_h1024_pad__jpg.webp?v=1742394326",
    ],
    description: "We recommend purchasing your normal size to ensure the pairfect fit — for example, a UK 7 should wear a UK 7. SKU CD6404-107.",
  },

  {
    id: "jordan-4-retro-fire-red-2020",
    title: "Jordan 4 Retro Fire Red (2020)",
    brand: "jordan",
    model: "jordan-4",
    price: 449.99,
    badge: "New",
    featured: true,
    sizes: ["7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11"],
    images: [
      "https://cdn.shopify.com/s/files/1/0985/2032/files/air-jordan-4-retro-fire-red-2020-dc7770-160_1_pf2i3n_1800x1800_1.jpg?v=1716665482",
    ],
    description: "The 2020 Fire Red returns with white leather, Fire Red overlays and that unmistakable grey heel mesh. A cornerstone silhouette, sourced for collectors who know the difference.",
  },
  {
    id: "air-jordan-1-retro-court-purple-2-0",
    title: "Air Jordan 1 Retro 'Court Purple' 2.0",
    brand: "jordan",
    model: "jordan-1",
    price: 289.99,
    badge: "Featured",
    featured: true,
    sizes: ["7", "8", "8.5", "9"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/COURTPURPLE2.jpg?v=1604280192"],
    description: "Court Purple leather against a crisp white midsole. A colourway that defined a generation of 1s — still one of the most requested pairs in the hut.",
  },
  {
    id: "air-jordan-1-retro-mid-chicago-toe",
    title: "Air Jordan 1 Retro Mid Chicago Toe",
    brand: "jordan",
    model: "jordan-1",
    price: 199.99,
    badge: "Just in",
    featured: true,
    sizes: ["7", "8.5"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/MIDTOECHICAGO.jpg?v=1604280507"],
    description: "Chicago DNA, mid-cut comfort. Varsity Red, black and white in the proportions that started everything.",
  },
  {
    id: "air-jordan-1-retro-shadow-2018",
    title: "Air Jordan 1 Retro 'Shadow' 2018",
    brand: "jordan",
    model: "jordan-1",
    price: 449.99,
    featured: true,
    sizes: ["8.5", "9", "10", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/Shadow_1.jpg?v=1572959040"],
    description: "Black and Medium Grey. Quiet, severe, and endlessly wearable. The 2018 Shadow remains a wardrobe essential.",
  },
  {
    id: "air-jordan-4-retro-red-cement",
    title: "Air Jordan 4 Retro 'Red Cement'",
    brand: "jordan",
    model: "jordan-4",
    price: 199.99,
    badge: "New",
    featured: true,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/redcement1.jpg?v=1707793503"],
    face: "left",
    faceLeft: true,
    description: "Cement speckles, Fire Red accents, and the 4's structural wings. A modern classic with OG energy.",
  },
  {
    id: "air-jordan-4-retro-infrared",
    title: "Air Jordan 4 Retro 'Infrared'",
    brand: "jordan",
    model: "jordan-4",
    price: 380,
    featured: true,
    sizes: ["7", "8", "8.5", "9", "9.5", "10", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/Air_Jordan_4_Retro_Infrared_b3792dc7-d649-4c36-87be-63eec9075ff5.png?v=1707792595"],
    description: "Infrared hits the netting, eyelets and branding. One of the most graphic 4s ever produced.",
  },
  {
    id: "nike-air-max-95-icons-yellow-strike",
    title: "Nike Air Max 95 Icons Yellow Strike",
    brand: "nike",
    model: "air-max-95",
    price: 209.99,
    badge: "New",
    featured: true,
    sizes: ["7", "8", "8.5", "9", "9.5", "10", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/Nike-air-max-95-icons-yellow-strike-dx4236-100-crepslocker-side.jpg?v=1707864402"],
    description: "Yellow Strike on the original anatomical Air Max. Neon that still looks like the future.",
  },
  {
    id: "nike-air-max-95-hyper-turquoise",
    title: "Nike Air Max 95 Hyper Turquoise",
    brand: "nike",
    model: "air-max-95",
    price: 249.99,
    badge: "Featured",
    featured: true,
    sizes: ["6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/nikeairmax95turq.png?v=1707794333"],
    description: "Hyper Turquoise gradients across the 95's ribbed upper. A colourway built for the dedicated Air Max collector.",
  },
  {
    id: "nike-air-max-95-dark-beetroot",
    title: "Nike Air Max 95 'Dark Beetroot'",
    brand: "nike",
    model: "air-max-95",
    price: 249.95,
    featured: true,
    sizes: ["6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/AirMax95DarkBeetroot.png?v=1707793666"],
    description: "Dark Beetroot suede and mesh with a smoked out midsole. Late-night energy, daytime presence.",
  },
  {
    id: "nike-air-max-95-sp-erdl-party-white",
    title: "Nike Air Max 95 SP ERDL Party 'White'",
    brand: "nike",
    model: "air-max-95",
    price: 264.99,
    sizes: ["8", "8.5", "9"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/ERDL_Party_95.jpg?v=1573581222"],
    description: "ERDL camo on a white base. Military print, party energy — a 95 for those who already own the obvious pairs.",
  },
  {
    id: "nike-air-max-1-patta-waves-white",
    title: "Nike Air Max 1 Patta Waves White",
    brand: "nike",
    model: "air-max-1",
    price: 398.99,
    badge: "Exclusive",
    featured: true,
    sizes: ["5", "5.5", "6", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/patta1_96b20052-2885-4a33-8fc3-5db380b87a9e.jpg?v=1707794566"],
    description: "Amsterdam's Patta reworks the Air Max 1 with wave overlays. A collaboration that sits at the centre of European sneaker culture.",
  },
  {
    id: "nike-air-force-1-shibuya-halloween",
    title: "Nike Air Force 1 'Shibuya Halloween'",
    brand: "nike",
    model: "air-force-1",
    price: 274.99,
    sizes: ["7.5", "8", "8.5", "9", "9.5", "11", "12"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/Shibuya_AF1.jpg?v=1573581334"],
    description: "A Japan-exclusive Halloween colourway. Shibuya nights, pumpkin graphics, and the most worn silhouette on earth.",
  },
  {
    id: "nike-react-element-87-red-orbit",
    title: "Nike React Element 87 'Red Orbit' Japan Exclusive",
    brand: "nike",
    model: "react",
    price: 199.99,
    sizes: ["7", "8.5", "9", "9.5"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/react_87.jpg?v=1573092279"],
    description: "Translucent React, Japan-only Red Orbit. The silhouette that pulled running tech into streetwear.",
  },
  {
    id: "air-jordan-1-mid-gs-ice-blue",
    title: "Air Jordan 1 Mid GS 'Ice Blue'",
    brand: "jordan",
    model: "jordan-1",
    price: 89.99,
    badge: "GS",
    sizes: ["3", "3.5", "4", "4.5", "5", "5.5", "6"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/air-jordan-1-mid-gs-ice-blue-555112-401_1.png?v=1707864083"],
    description: "Ice Blue on a Grade School 1 Mid. Light, clean, and an easy entry into the Jordan lineage.",
  },
  {
    id: "yeezy-boost-350-v2-cloud-white",
    title: "Yeezy Boost 350 V2 'Cloud White'",
    brand: "yeezy",
    model: "350",
    price: 349.99,
    featured: true,
    sizes: ["7.5", "8", "8.5", "9", "10"],
    images: ["images/catalogue/yeezy-350-v2-cloud-white.jpg"],
    description: "Primeknit in Cloud White with the full-length Boost midsole. Quiet luxury in the Yeezy vocabulary.",
  },
  {
    id: "yeezy-boost-350-v2-triple-black",
    title: "Yeezy Boost 350 V2 'Triple Black'",
    brand: "yeezy",
    model: "350",
    price: 429.99,
    sizes: ["6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10.5", "11"],
    images: ["images/catalogue/yeezy-350-v2-triple-black.jpg"],
    description: "All-black Primeknit and a hidden Boost. The pair that disappears into a wardrobe and still leads it.",
  },
  {
    id: "yeezy-700-wave-runner-og",
    title: "Yeezy 700 Wave Runner OG",
    brand: "yeezy",
    model: "700",
    price: 449.99,
    featured: true,
    sizes: ["7", "8", "8.5", "9", "10", "11"],
    images: ["images/catalogue/yeezy-700-wave-runner.jpg"],
    description: "The original Wave Runner. Teal, grey and that dad-shoe proportion that rewired the market in 2017.",
  },
  {
    id: "air-jordan-retro-4-bred-2019",
    title: "Air Jordan Retro 4 'Bred' 2019",
    brand: "jordan",
    model: "jordan-4",
    price: 549.99,
    badge: "Heat",
    featured: true,
    sizes: ["7", "9", "9.5"],
    images: ["images/catalogue/jordan-4-bred-2019.jpg"],
    face: "left",
    faceLeft: true,
    description: "Black, Cement Grey and Varsity Red. The 2019 Bred 4 is still the one most people mean when they say '4s'.",
  },
  {
    id: "nike-air-max-97-shanghai-kaleidoscope",
    title: "Nike Air Max 97 QS Shanghai Kaleidoscope",
    brand: "nike",
    model: "air-max-97",
    price: 529.99,
    badge: "Rare",
    featured: true,
    sizes: ["7", "8.5", "9", "11"],
    images: ["images/catalogue/air-max-97-shanghai.jpg"],
    description: "Shanghai's kaleidoscope graphic on the 97. A city exclusive that barely made it out of Asia.",
  },
  {
    id: "nike-air-max-90-off-white-desert-ore",
    title: "Nike Air Max 90 x Off-White 'Desert Ore'",
    brand: "off-white",
    model: "air-max-90",
    price: 549.99,
    soldOut: true,
    sizes: [],
    images: ["images/catalogue/off-white-am90-desert-ore.jpg"],
    description: "Virgil's take on the 90. Helvetica, zip ties, and Desert Ore suede. Sold through — join the waitlist.",
  },
  {
    id: "nike-air-max-97-off-white-menta",
    title: "Nike Air Max 97 x Off-White 'Menta'",
    brand: "off-white",
    model: "air-max-97",
    price: 899.99,
    sizes: ["7.5", "10", "11"],
    images: ["images/catalogue/off-white-am97-menta.jpg"],
    description: "Menta green, exposed-foam tongue, and The Ten's industrial detailing on the original 97 last.",
  },
  {
    id: "nike-air-max-97-1-vf-x-sean-wotherspoon",
    title: "Nike Air Max 97/1 VF x Sean Wotherspoon",
    brand: "nike",
    model: "air-max-97",
    price: 999.99,
    badge: "Grail",
    featured: true,
    sizes: ["8", "9", "10"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/SW_97_1.jpg?v=1521511739"],
    description: "Corduroy, wildflowers, and the hybrid 97/1 last. Still the most photographed Air Max of the last decade.",
  },
  {
    id: "air-jordan-retro-1-banned",
    title: "Air Jordan 1 Retro 'Banned' 2016",
    brand: "jordan",
    model: "jordan-1",
    price: 649.99,
    badge: "Grail",
    featured: true,
    sizes: ["7.5", "8.5", "10.5", "11", "12"],
    images: ["https://cdn.shopify.com/s/files/1/0985/2032/products/BANNEDJ1.jpg?v=1604467378"],
    description: "Black, Varsity Red, and the 2016 Banned return. The pair that started the conversation — 555088-001.",
  },
  {
    id: "air-jordan-retro-11-bred",
    title: "Air Jordan Retro 11 'Bred'",
    brand: "jordan",
    model: "jordan-11",
    price: 349.99,
    sizes: ["8", "8.5", "9", "9.5", "10", "10.5"],
    images: ["images/catalogue/jordan-11-bred.jpg"],
    description: "Patent leather, carbon fibre, and Christmas-day folklore. The Bred 11 is the dress shoe of the culture.",
  },
  {
    id: "crephut-rope-laces-3m-black",
    title: "Crephut Rope Laces — 3M Reflective / Black",
    brand: "accessories",
    model: "laces",
    price: 4.99,
    sizes: ["One size"],
    images: ["images/catalogue/rope-laces-black.jpg"],
    description: "House laces. 3M reflective weave in black. Swap them onto anything in the rotation.",
  },
];

window.CREPHUT_TRUSTPILOT = "https://www.trustpilot.com/review/crephut.com";
window.CREPHUT_REVIEWS = [
  { name: "Phil", location: "United Kingdom", rating: 5, date: "March 2021", text: "Great selection of sought-after products, at reasonable prices. The team's communication is great and despite a small issue with stock, it was handled really well." },
  { name: "Nick M.", location: "United Kingdom", rating: 5, date: "November 2020", text: "Great service and excellent communication. Shoes received within 24 hours. Would definitely recommend." },
  { name: "Simon G.", location: "United Kingdom", rating: 5, date: "October 2019", text: "Ordered a few pairs now and each time they’ve turned up in two days, well packaged and with tags attached." },
  { name: "Martin B.", location: "United Kingdom", rating: 5, date: "June 2019", text: "Trainers arrived and they are mint. Any questions I had they were answered promptly — Crephut are a collector's dream." },
  { name: "Alex K.", location: "United Kingdom", rating: 5, date: "May 2019", text: "Got Air Jordan 1s Court Purple. Payment was smooth and easy, delivery was very quick and the shoes are just beautiful." },
];
